<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('distributors.create.btnLabel') }}
    </base-button>

    <modal id="CreateDistributor"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('distributors.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('distributors.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('generic.status') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="status"
                :value="itemToCreate.status"
                disabled
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.type') }}</label>
            <div class="col-sm-8 form-group">
                <el-select
                  name="type"
                  data-vv-as="'type'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="itemToCreate.type">
                  <el-option
                    v-for="option in distributorTypes"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option">
                  </el-option>
                </el-select>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.company_name') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="company_name"
                v-validate="modelValidations.required"
                :error="getError('company_name')"
                v-model="itemToCreate.company_name"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.email') }}</label>
            <div class="col-sm-8">
              <base-input
                type="email"
                name="email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                v-model="itemToCreate.email"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.form.password') }}</label>
            <div class="col-sm-8">
              <base-input
                type="password"
                name="password"
                v-validate="modelValidations.required"
                :error="getError('password')"
                v-model="itemToCreate.password"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.contact_number') }}</label>
            <div class="col-sm-8">
              <base-input
                type="string"
                name="contact_number"
                v-validate="modelValidations.required"
                :error="getError('contact_number')"
                v-model="itemToCreate.contact_number"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.cidrs') }}</label>
            <div class="col-sm-8">
              <div class="form-group">
                <tags-input v-model="itemToCreate.cidrs"
                            :input-placeholder="$t('distributors.form.cidrPlaceholder')"
                            input-size="" tag-size="medium"></tags-input>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">{{ $t('distributors.details.client_access_status') }}</label>
            <div class="col-sm-8 form-group">
                <el-select
                  class="select-primary"
                  size="large"
                  name="role"
                  v-model="itemToCreate.client_access_status"
                >
                  <el-option
                    v-for="option in distributorClientStatuses"
                    class="select-primary"
                    :value="option"
                    :label="$t(`clientAccessStatuses.${option}`)"
                    :key="option"
                  >
                  </el-option>
                </el-select>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              class="my-4"
              @click="validate()"
              :loading="updating"
            >{{ $t('distributors.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal, TagsInput} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";

export default {
  name: 'create-distributor',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert,
    TagsInput
  },
  data() {
    return {
      modal: false,
      alert: false,
      itemToCreate: {
        company_name: '',
        contact_number: '',
        type: '',
        email: '',
        password: '',
        cidrs: ["0.0.0.0/0", "0::0/0"],
        client_access_status: 'allow',
        status: "ok"
      },
      modelValidations: {
        required: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        number: {
          numeric: true
        },
        url: {
          url: true
        },
        equalToSource: {
          required: true
        },
        equalToDest: {
          required: true,
          confirmed: 'equalToSource'
        }
      },
    }
  },
  computed: {
    ...mapState({
      loading: state => state.distributors.loading,
      updating: state => state.distributors.updating,
      error: state => state.distributors.error,
      single: state => state.distributors.single,
      distributorTypes: state => state.distributors.distributorTypes,
      distributorClientStatuses: state => state.distributors.distributorClientStatuses,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
  },
  methods: {
    ...mapActions(['CreateDistributor', 'ClearCreated', 'LoadDistributors']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.CreateDistributor(this.itemToCreate).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('distributors.create.createdNotification', this.itemToCreate),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.$router.push({
            name: 'distributor',
            params: {id: this.single.id}
          }).catch(err => {
          })

          swal({
            title: this.$t('distributors.create.createdDetailsTitle'),
            text: this.$t('distributors.create.createdDetailsNotification', {secret: this.single.secret}),
            buttonsStyling: false,
            confirmButtonText: this.$t('psw.viewBtnLabel'),
            confirmButtonClass: 'btn btn-primary',
            type: 'info',
          })

          // Remove important data from  the memory.
          this.ClearCreated();

          this.resetForm()
        }
      });
    },
    resetForm: function () {
      this.modal = false;
      this.alert = false;
      // resetting form
      this.itemToCreate = {
        company_name: '',
        contact_number: '',
        email: '',
        password: '',
        cidrs: ["0.0.0.0/0", "0::0/0"],
        client_access_status: 'allow',
        status: 'ok'
      }

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
